import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  urlEntries: [],
  loadingUrlEntries: false,
};

const urlEntrySlice = createSlice({
  name: "urlEntry",
  initialState,
  reducers: {
    loadingUrlEntries(state) {
      state.loadingUrlEntries = true;
    },
    loadingUrlEntriesDone(state) {
      state.loadingUrlEntries = false;
    },
    setUrlEntries(state, action) {
      state.urlEntries = action.payload;
    },
  },
});

export const { loadingUrlEntries, loadingUrlEntriesDone, setUrlEntries } =
  urlEntrySlice.actions;

export default urlEntrySlice.reducer;
